module.exports = __webpack_public_path__ + "img/red-cw-logo.dc13c2b0.svg";